import React from 'react';
import '../styles/global.css'; // Seu CSS global
import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { 
  AccessAlarm, 
  ThreeDRotation, 
  WavingHand, 
  TwoWheeler, 
  Verified, 
  AdsClick, 
  Map, 
  SportsMotorsports, 
  Moped, 
  Menu, 
  PlayCircle, 
  PauseCircle,
  GraphicEq,
  Audiotrack, Videocam, VideoLibrary,
  VolumeUp, PrivacyTip, Instagram, Facebook,
  Download} from '@mui/icons-material';
// import hino_MGBE from '../assets/audio/Brasil Extremos - Hino.mp3';
import hino_MP4 from '../assets/video/MGBE-Pulsa-o-Coracao.mp4';


function Sobre() {
  const [cidades, setCidades] = useState([]);

  const [audio] = useState(new Audio('https://www.brasilextremos.com.br/api/midia/Brasil Extremos - Hino.mp3'));
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPlaying2, setIsPlaying2] = useState(false);

  const togglePlay = () => {
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);

    //salvar log de navegação
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Audio",
      logModulo: "Inicio do Hino do MGBE - Áudio",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });

  };

  const togglePlay2 = () => {
    // if (isPlaying2) {
    //   audio.pause();
    // } else {
    //   audio.play();
    // }
    setIsPlaying2(!isPlaying2);

  //salvar log de navegação
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Vídeo",
      logModulo: "Inicio do Hino do MGBE - Vídeo Clipe",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  };

  useEffect(() => {
    audio.addEventListener('ended', () => setIsPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setIsPlaying(false));
    };
  }, [audio]);

  useEffect(() => {
    isPlaying ? audio.play() : audio.pause();
  }, [isPlaying, audio]);

  useEffect(() => {
      var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
      axios
        .post(
          process.env.REACT_APP_API_URL +
          '/routes.php?metodo=obtemPessoasAgrupadasPorEstado', null,
          {
            headers: {
              "X-Access-Token": token,
              "Content-Type": "application/json; charset=utf-8",
            }
          }
        )
        .then((response) => {
          setCidades(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
  },[])

  const letraHino = [
    { tempo: 0, texto: "... ♪ (Intro Instrumental) ..." },
    { tempo: 31, texto: "O asfalto chama, o motor desperta" },
    { tempo: 38, texto: "Vento no rosto, a alma sempre aberta" },
    { tempo: 44, texto: "De Norte a Sul, sem fronteira ou final" },
    { tempo: 51, texto: "Somos Brasil Extremos, um ideal" },
    { tempo: 60, texto: "Irmandade, respeito, igualdade e honra" },
    { tempo: 67, texto: "Nossa bandeira a estrada nos aponta" },
    { tempo: 74, texto: "Unidos pela força, na mesma direção" },
    { tempo: 81, texto: "Brasil Extremos, pulsa o coração" },
    { tempo: 94, texto: "Nos encontros, a festa e união" },
    { tempo: 100, texto: "Em cada evento, estendemos a mão" },
    { tempo: 107, texto: "Ação social, que faz a diferença" },
    { tempo: 114, texto: "Nossa missão, nossa maior recompensa." },
    { tempo: 122, texto: "Irmandade, respeito, igualdade e honra" },
    { tempo: 129, texto: "Nossa bandeira a estrada nos aponta" },
    { tempo: 135, texto: "Unidos pela força, na mesma direção" },
    { tempo: 143, texto: "Brasil Extremos, pulsa o coração" },
    { tempo: 169, texto: "Mais que um grupo, uma família de aço" },
    { tempo: 177, texto: "Lado a lado, em cada passo" },
    { tempo: 183, texto: "Se um de nós cai, o outro vai levantar" },
    { tempo: 190, texto: "Juntos na Glória, prontos pra acelerar" },
    { tempo: 198, texto: "Irmandade, respeito, igualdade e honra" },
    { tempo: 205, texto: "Nossa bandeira a estrada nos aponta" },
    { tempo: 211, texto: "Unidos pela força, na mesma direção" },
    { tempo: 218, texto: "Brasil Extremos, pulsa o coração" }
  ];

  const audioRef = useRef(null);
  const containerLetraRef = useRef(null);
  
  const [tempoAtual, setTempoAtual] = useState(0);
  const [linhaAtiva, setLinhaAtiva] = useState(0);

  // Atualiza o tempo da música e descobre qual linha deve ficar ativa
  const lidarComTimeUpdate = () => {
    if (!audioRef.current) return;
    
    const tempo = audioRef.current.currentTime;
    setTempoAtual(tempo);

    // Encontra o índice da linha atual com base no tempo
    const indiceLinha = letraHino.findIndex((linha, index) => {
      const proximaLinha = letraHino[index + 1];
      return tempo >= linha.tempo && (!proximaLinha || tempo < proximaLinha.tempo);
    });

    if (indiceLinha !== -1 && indiceLinha !== linhaAtiva) {
      setLinhaAtiva(indiceLinha);
    }
  };

  // Efeito para rolar a div automaticamente quando a linha ativa mudar
  useEffect(() => {
    if (containerLetraRef.current) {
      const elementoLinhaAtiva = containerLetraRef.current.children[linhaAtiva];
      if (elementoLinhaAtiva) {
        elementoLinhaAtiva.scrollIntoView({
          behavior: 'smooth',
          block: 'center', // Centraliza a linha ativa na tela
        });
      }
    }
  }, [linhaAtiva]);

  const videoRef = useRef(null);
  
  const DATA_LANCAMENTO = "2026-06-05T20:00:00";
  const opcoes = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false // Garante o formato de 24 horas
  };
  const [estaDisponivel, setEstaDisponivel] = useState(false);
  const [tempoRestante, setTempoRestante] = useState({ dias: 0, horas: 0, minutos: 0, segundos: 0 });

  // 1. Lógica da Contagem Regressiva
  useEffect(() => {
    const calcularTempo = () => {
      const agora = new Date().getTime();
      const dataAlvo = new Date(DATA_LANCAMENTO).getTime();
      const diferenca = dataAlvo - agora;

      if (diferenca <= 0) {
        setEstaDisponivel(true);
        return true; // Retorna true para limpar o intervalo
      }

      // Cálculos matemáticos para tempo restante
      const dias = Math.floor(diferenca / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diferenca % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutos = Math.floor((diferenca % (1000 * 60 * 60)) / (1000 * 60));
      const segundos = Math.floor((diferenca % (1000 * 60)) / 1000);

      setTempoRestante({ dias, horas, minutos, segundos });
      return false;
    };

    // Executa imediatamente na montagem do componente
    const terminou = calcularTempo();
    if (terminou) return;

    // Atualiza a cada 1 segundo
    const intervalo = setInterval(() => {
      const acabou = calcularTempo();
      if (acabou) clearInterval(intervalo);
    }, 1000);

    return () => clearInterval(intervalo);
  }, []);


  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página Sobre",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  
  return (
    <div style={{ paddingBottom: '80px' }}>
      <main>
        <div>
          <div className='headerMain'>
            <label className='labelTitulo' ><h2>Somos Brasil Extremos</h2></label>
          </div>
        </div>

        <div className='w100'>
          <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
            <Instagram onClick={() => window.open('https://www.instagram.com/brasilextremosmg', '_blank')} style={{ width: 50, height: 50, marginRight: '10px', cursor: 'pointer' }} />
            <Facebook onClick={() => window.open('https://www.facebook.com/groups/383883379922876', '_blank')} style={{ width: 50, height: 50, cursor: 'pointer' }} />
          </p>
        </div>

        

        <div className='d-flex w100 flex-column flex-md-row justify-content-center align-items-start gap-4'>
          {/* <div className='boxCenter align-items-center'> */}
            <div className='boxCenter'>
              <VolumeUp style={{ width: 50, height: 50 }} /><h2 className='title'><span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>"Pulsa o Coração"</span><br />O Hino do MGBE </h2>
              <p className='text'>
                ... O hino do Moto Grupo Brasil Extremos, uma ode à paixão e à irmandade 
                que une os motociclistas de todo o país.
                Com versos que ecoam a liberdade das estradas e a força da união, 
                o hino é um símbolo de identidade e orgulho para todos os membros do grupo.
                Ele celebra a jornada sobre duas rodas, a camaradagem entre os motociclistas 
                e o compromisso com a segurança e o respeito mútuo.
                Ao entoar essas palavras, os membros do Moto Grupo Brasil Extremos reafirmam 
                seu amor pelo motociclismo e sua dedicação à comunidade que compartilha essa paixão. 
                </p>
            </div>


            {!estaDisponivel ? (
            // <div style={{ textAlign: 'center', animation: 'fadeIn 0.5s ease-in-out' }}>
            <div className='boxCenter'>
              <h2 style={{ marginBottom: '30px', marginTop: '30px', color: '#dc7b0c' }}>
                <p className='text'>O LANÇAMENTO ESTÁ CHEGANDO!</p>
              </h2>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                {[
                  { label: 'Dias', valor: tempoRestante.dias },
                  { label: 'Horas', valor: tempoRestante.horas },
                  { label: 'Min.', valor: tempoRestante.minutos },
                  { label: 'Seg.', valor: tempoRestante.segundos }
                ].map((item, index) => (
                  <div key={index} style={{
                    backgroundColor: '#1e1e1e',
                    padding: '20px',
                    borderRadius: '12px',
                    minWidth: '80px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                    border: '1px solid #333'
                  }}>
                    <div style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
                      {String(item.valor).padStart(2, '0')}
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#888', marginTop: '5px', textTransform: 'uppercase' }}>
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>
              <p style={{ marginTop: '30px', color: '#FFF' }}>Disponível em: {new Date(DATA_LANCAMENTO).toLocaleString('pt-BR', opcoes)}</p>
            </div>
            ) : (
            // <div>
            <div className='boxCenter'>
              <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', alignItems: 'center' }}>
              <h2 className='title'><Audiotrack /> <GraphicEq /> MGBE Pulsa o Coração
              {/* {isPlaying ? (
                <PauseCircle style={{ cursor: 'pointer', width: 40, height: 40, marginLeft: '10px', marginBottom: '-12px', color: '#cd8717' }} onClick={togglePlay} />
              ) : (
                <PlayCircle style={{ cursor: 'pointer', width: 40, height: 40, marginLeft: '10px', marginBottom: '-12px', color: '#17cd39' }} onClick={togglePlay} />
              )} */}
              </h2>
              </div>
            
              <div>
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px', alignSelf: 'center', alignItems: 'center' }}>
                  <audio 
                    ref={audioRef} 
                    src='https://www.brasilextremos.com.br/api/midia/Brasil Extremos - Hino.mp3'
                    controls 
                    controlsList='download' 
                    onContextMenu={(e) => e.preventDefault()}
                    onTimeUpdate={lidarComTimeUpdate} 
                    onPlaying={togglePlay} onPause={togglePlay} />
                    <div 
                      ref={containerLetraRef}
                      style={{
                        // display: isPlaying2 ? 'block' : 'none',
                        marginTop: '20px',
                        width: '100%',
                        height: '250px',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        padding: '10px',
                        textAlign: 'center',
                        backgroundColor: '#121212',
                        color: '#fff',
                        scrollBehavior: 'smooth' 
                      }}
                      >
                      {letraHino.map((linha, index) => (
                        <p 
                        key={index} 
                        style={{ 
                          padding: '10px 0',
                          margin: 0,
                          fontSize: index === linhaAtiva ? '1.3rem' : '1.1rem',
                          fontWeight: index === linhaAtiva ? 'bold' : 'normal',
                          color: index === linhaAtiva ? '#1db954' : '#898787', // Verde estilo Spotify para a ativa
                          transition: 'all 0.4s ease',
                          }}>
                          {linha.texto}
                        </p>
                      ))}
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px', alignSelf: 'center', alignItems: 'center' }}>
                  <h2 className='title pt3'><Videocam /> <VideoLibrary /> MGBE Pulsa o Coração (Vídeo Clipe)</h2>
                  <video 
                    ref={videoRef}
                    src={hino_MP4} 
                    controls 
                    controlsList='nodownload'
                    onContextMenu={(e) => e.preventDefault()}
                    onTimeUpdate={lidarComTimeUpdate}
                    onPlaying={togglePlay2} onPause={togglePlay2}
                    style={{
                      maxHeight: '500px',
                      width: 'auto',
                      maxWidth: '600px',
                      borderRadius: '8px',
                      boxShadow: '0px 4px 15px rgba(0,0,0,0.7)',
                      border: '1px solid #333'
                    }}
                  />
                </div>
              </div>
            </div>
            )}

            {/* <div style={{ display: isPlaying ? 'block' : 'none' }}>
              <div className='text mt3' >
                <br />
                <br />
                O asfalto chama, o motor desperta <br />
                Vento no rosto, a alma sempre aberta <br />
                De Norte a Sul, sem fronteira ou final <br />
                Somos Brasil Extremos, um ideal <br />
                <br />
                Irmandade, respeito, igualdade e honra <br />
                Nossa bandeira a estrada nos aponta <br />
                Unidos pela força, na mesma direção <br />
                Brasil Extremos, pulsa o coração <br />
                <br />
                Nos encontros, a festa e união <br />
                Em cada evento, estendemos a mão <br />
                Ação social, que faz a diferença <br />
                Nossa missão, nossa maior recompensa. <br />
                <br />
                Irmandade, respeito, igualdade e honra <br />
                Nossa bandeira a estrada nos aponta <br />
                Unidos pela força, na mesma direção <br />
                Brasil Extremos, pulsa o coração <br />
                <br />
                Mais que um grupo, uma família de aço <br />
                Lado a lado, em cada passo <br />
                Se um de nós cai, o outro vai levantar <br />
                Juntos na Glória, prontos pra acelerar <br />
                <br />
                Irmandade, respeito, igualdade e honra <br />
                Nossa bandeira a estrada nos aponta <br />
                Unidos pela força, na mesma direção <br />
                Brasil Extremos, pulsa o coração <br />
                <br />
                Brasil Extremos, pulsa o coração <br />
              </div>
            </div> */}

            <div className='boxCenter'>
              <TwoWheeler style={{ width: 50, height: 50 }} /><h2 className='title'>Nossa Missão</h2>
              <p className='text'>Promover a união, o apoio mútuo e a camaradagem entre os motociclistas, incentivando a prática segura do motociclismo e a participação ativa em eventos e atividades relacionadas à cultura motociclista.</p>
            </div>
            <div className='boxCenter'>
              <Verified style={{ width: 50, height: 50 }} /><h2 className='title'>Nossos Valores</h2>
              <p className='text'>Respeito, solidariedade, segurança, amizade e paixão pelo motociclismo são os pilares que sustentam nossa associação. Valorizamos a diversidade e buscamos criar um ambiente inclusivo para todos os motociclistas, independentemente de sua experiência ou estilo de pilotagem.</p>
            </div>
            <div className='boxCenter'>
              <AdsClick style={{ width: 50, height: 50 }} /><h2 className='title'>Nossos Objetivos</h2>
              <p className='text'>Organizar eventos, passeios e encontros para promover a interação entre os membros, oferecer suporte e assistência aos motociclistas em situações de emergência, incentivar a prática segura do motociclismo por meio de campanhas de conscientização e educação, e representar os interesses dos motociclistas junto às autoridades e à sociedade em geral.</p>
            </div>
            <div className='boxCenter'>
              <Map style={{ width: 50, height: 50 }} /><h2 className='title'>Nossa Presença</h2>
              <p className='text'>Com membros e associados de 14 estados e o Distrito Federal, o Moto Grupo Brasil Extremos está presente em diversas regiões do país, promovendo a cultura motociclista e fortalecendo os laços entre os motociclistas de todo o Brasil.</p>
            </div>
            
            <div className='boxCenter'>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <SportsMotorsports style={{ width: 50, height: 50 }} />
                <Moped style={{ width: 50, height: 50 }} />
                <TwoWheeler style={{ width: 50, height: 50 }} />
                <Menu style={{ width: 50, height: 50 }} />
              </div>
              {cidades.map((item, index) => (
                <div key={index}>
                  <p>{item.pesCidade} - {item.pesEstado}</p>
                  {/* : {item.total} associados */}
                </div>
              ))} 
            </div>
          {/* </div> */}
        
        </div>

        <div>
          <div className='headerMain'>
            <Link to="/Contato/0" style={{ textDecoration: 'none', color: '#FFF' }}>
            <WavingHand style={{ width: 50, height: 50 }} />
              <h3>Junte-se a Nós!</h3>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Sobre;